import React from 'react';

import navigateToURL from 'lib/navigateToURL';

interface StepDocumentLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
}

export default function StepDocumentLink(props: StepDocumentLinkProps): JSX.Element {
  return (
    <a
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        navigateToURL(props.href);
      }}
      {...props}
    />
  );
}
